export default {
  loading: true,
  elements: {},
  rules: {},
};
